import { useEffect, useRef } from 'react';
import type { WebappResponse } from '@eventbrite/event-listing-service-client';

import { sendEventViewTracking } from '@/utils/eventViewTracking';

type UseEventViewTrackingEffectArgs = {
  pageContext: WebappResponse | null | undefined;
  isPreview: boolean | undefined;
};

export function useEventViewTrackingEffect({ pageContext, isPreview }: UseEventViewTrackingEffectArgs) {
  const eventViewTrackedEventIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (isPreview || !pageContext?.basicInfo?.id) {
      return;
    }

    if (eventViewTrackedEventIdRef.current === pageContext.basicInfo.id) {
      return;
    }

    eventViewTrackedEventIdRef.current = pageContext.basicInfo.id;
    sendEventViewTracking();
  }, [pageContext, isPreview]);
}
